import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Layers, Heart, Repeat, ShieldCheck, UserCheck, Handshake } from "lucide-react";

const STEPS = [
  [Layers, "Aggiungi le carte disponibili", "Inserisci le carte che possiedi e vuoi scambiare, con quantità, lingua e condizione. Puoi caricare foto fronte e retro."],
  [Heart, "Indica le carte che cerchi", "Crea la tua wishlist con priorità, lingue accettate e condizione minima. La wishlist è privata per impostazione predefinita."],
  [Repeat, "Trova corrispondenze reciproche", "Il matching individua gli abbinamenti reali: tu possiedi qualcosa che l'altra persona cerca e viceversa."],
  [Handshake, "Proponi e completa lo scambio", "Invia una proposta carta contro carta, accordati sul recapito e confermate entrambi il completamento."],
];

export default function HowItWorks() {
  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="font-display text-3xl font-bold text-[#F8FAFC] sm:text-4xl">Come funziona Omniverse</h1>
      <p className="mt-3 text-lg text-[#CBD5E1]">Un percorso semplice e concreto: dalle carte disponibili alla wishlist, fino all'incontro e allo scambio. Tutto gratuito, sempre carta contro carta.</p>

      <div className="mt-8 space-y-4">
        {STEPS.map(([Icon, t, d], i) => (
          <div key={t} className="flex gap-4 rounded-2xl border border-[#2A3655] bg-[#141B2D] p-5">
            <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#7C3AED]/15 font-display font-bold text-[#7C3AED]">{i + 1}</div>
            <div>
              <h2 className="flex items-center gap-2 font-display text-lg font-semibold text-[#F8FAFC]"><Icon className="h-4 w-4 text-[#2DD4BF]" />{t}</h2>
              <p className="mt-1 text-sm text-[#CBD5E1]">{d}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        <div className="rounded-xl border border-[#2A3655] bg-[#1C2640] p-5">
          <UserCheck className="h-5 w-5 text-[#2DD4BF]" />
          <h3 className="mt-2 font-display font-semibold text-[#F8FAFC]">Riservato ai maggiorenni</h3>
          <p className="mt-1 text-sm text-[#CBD5E1]">La registrazione richiede una dichiarazione di maggiore età. Non chiediamo documenti né la data di nascita completa.</p>
        </div>
        <div className="rounded-xl border border-[#2A3655] bg-[#1C2640] p-5">
          <ShieldCheck className="h-5 w-5 text-[#2DD4BF]" />
          <h3 className="mt-2 font-display font-semibold text-[#F8FAFC]">Scambi con attenzione</h3>
          <p className="mt-1 text-sm text-[#CBD5E1]">Omniverse non custodisce né spedisce carte e non garantisce gli scambi. L'accordo resta tra i collezionisti.</p>
        </div>
      </div>

      <div className="mt-8 flex gap-3">
        <Button asChild className="bg-[#7C3AED] hover:bg-[#6D28D9]"><Link to="/registrati" data-testid="how-cta-register">Entra nella community</Link></Button>
        <Button asChild variant="outline" className="border-[#2A3655] bg-transparent text-[#F8FAFC] hover:bg-[#1C2640]"><Link to="/scambi">Esplora gli scambi</Link></Button>
      </div>
    </div>
  );
}
